import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ForceCursorEndDirective } from './central.directive';
import { CentralPipe } from './central.pipe';
import { MacroPostoComponent } from './macro-posto/macro-posto.component';
import { MenuCombustiveisComponent } from './menu-combustiveis/menu-combustiveis.component';
import { TelaPrincipalComponent } from './tela-principal/tela-principal.component';
import { MatIconModule } from "@angular/material/icon";

export const routes: Routes = [{ path: '', component: TelaPrincipalComponent }];

@NgModule({
  declarations: [
    CentralPipe,
    TelaPrincipalComponent,
    MenuCombustiveisComponent,
    MacroPostoComponent,
    ForceCursorEndDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(routes),
    CurrencyMaskModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule
],
})
export class CentralAjustePrecosModule {}
